
import React, { useEffect } from "react";
import Hero from "@/components/home/Hero";
import AboutSection from "@/components/home/AboutSection";
import SDGGrid from "@/components/home/SDGGrid";
import FeaturedStories from "@/components/home/FeaturedStories";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { storiesData } from "@/data/stories";
import { getImagePreviewPath } from "@/components/admin/stories/utils/imageHandlers";

const Index: React.FC = () => {
  // Add useEffect to log when the page loads for debugging
  useEffect(() => {
    console.log("Index page loaded - rendering all sections");
    
    // Debug featured stories image paths
    const featuredStories = storiesData.filter(story => story.featured);
    console.log("Featured stories:", featuredStories.map(story => ({
      id: story.id,
      title: story.title.en,
      originalImagePath: story.image,
      resolvedImagePath: getImagePreviewPath(story.image)
    })));
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <AboutSection />
      <SDGGrid />
      <FeaturedStories />
      <Footer />
    </div>
  );
};

export default Index;
